import { useQuery } from '@tanstack/react-query';
import { httpService } from '../../../utils/apiService';

export const useGetLocationOwnerForOperator = (params = {}, options = {}) => {
  const { operatorId, page, pageSize = 10 } = params;
  return useQuery({
    queryKey: ['SELECTED_LocationOwnerForOperator', operatorId, page, pageSize],
    queryFn: async () => {
      const response = await httpService.get(
        `operator/get-location-owners/${operatorId}?limit=${pageSize}&offset=${page}`
      );

      return response.data.data;
    },
    ...options,
  });
};
